
import api from "../../../api/api"

const  serialize = (obj) =>{
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
      console.log(str)
    return str.join("&");
}

const getTeamList = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("ess/team/list").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getTeamLeaveRequestList = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("ess/team/leave-request").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const getTeamWorkReportList = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("ess/team/work-report?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getAttendanceList = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("ess/team/attendance").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const managerDoPunch = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("ess/team/attendance",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const essTeamServices = {
    getTeamList,
    getTeamWorkReportList,
    getTeamLeaveRequestList,
    getAttendanceList,
    managerDoPunch
}
export default essTeamServices;